import { styled } from "styled-components"
import { useRecoilValue } from "recoil"
import signupStepState from "../../recoil/signupStep/atom"
import { FormProvider, useForm } from "react-hook-form"
import signupInfoSchema from "./signupInfoSchema"
import { yupResolver } from "@hookform/resolvers/yup"
import SignupFormStep1 from "./SignupFormStep1"
import SignupFormStep2 from "./SignupFormStep2"
import SignupFormStep3 from "./SignupFormStep3"

const SignupForm = () => {
  const signupStep = useRecoilValue(signupStepState)

  const methods = useForm({
    resolver: yupResolver(signupInfoSchema),
    mode: "onBlur",
  })

  return (
    <FormProvider {...methods}>
      <InputContainerDiv>
        {signupStep === 1 && <SignupFormStep1 />}
        {signupStep === 2 && <SignupFormStep2 />}
        {signupStep === 3 && <SignupFormStep3 />}
      </InputContainerDiv>
    </FormProvider>
  )
}

export default SignupForm

const InputContainerDiv = styled.div`
  box-sizing: border-box;
  min-height: calc(100vh - 320px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 40px 40px;

  @media ${({ theme }) => theme.device.pc} {
    width: 40vw;
    margin: 0 auto;
  }
`
